<div class="col-sm-12">
  <ngx-dropzone (change)="onFileSelect($event)">
    <ngx-dropzone-label>Drop file, here!</ngx-dropzone-label>
    <ngx-dropzone-preview *ngFor="let f of files" [removable]="manageAttachementsHcps" (removed)="onFileRemove(f)">
      <ngx-dropzone-label> ({{ f.contentType }})</ngx-dropzone-label>
    </ngx-dropzone-preview>
  </ngx-dropzone>
</div>
<div class="col-sm-12">
  <a *ngFor="let f of files" href="javascript:void(0)" (click)="openFile(f.fileUrl)" style="margin-right: 10%;">{{ f.fileName }}</a>
</div>

<div class="panel-footer margin-left-20 margin-top-20 margin-left-37">
  <button class="btn  btn-cancel" type="button" (click)="back()">{{'app.cancel' | translate}}</button>&nbsp;
  <button class="btn  btn-save" (click)="saveAttachements()" *ngIf="manageAttachementsHcps">{{'app.save' | translate}}</button>
</div>
